import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../Components/Navbar";
import SearchBar from "../Components/SearchBar";
import HelpMessage from "../Components/HelpMessage";

const getStoredSupplierCode = () => {
  const stored = localStorage.getItem("currentUser");
  return stored ? stored.trim() : "";
};

const Compare = () => {
  const [matrix, setMatrix] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [supplierCode, setSupplierCode] = useState(getStoredSupplierCode());

  useEffect(() => {
    const fetchCompare = async () => {
      if (!supplierCode) {
        setLoading(false);
        setError("");
        setMatrix({ columns: [], rows: [] });
        return;
      }
      try {
        setLoading(true);
        setError("");
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: { supplier: supplierCode }
        };
        const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/api/compare`, config);
        setMatrix(response.data || { columns: [], rows: [] });
      } catch (err) {
        console.error("Error loading compare data", err);
        setError("Unable to load comparison data right now.");
        setMatrix({ columns: [], rows: [] });
      } finally {
        setLoading(false);
      }
    };

    fetchCompare();
  }, [supplierCode]);

  useEffect(() => {
    const handleSupplierChange = (event) => {
      const next = event?.detail?.supplier?.trim() || getStoredSupplierCode();
      setSupplierCode(next);
    };

    window.addEventListener("supplierContextChanged", handleSupplierChange);
    return () => {
      window.removeEventListener("supplierContextChanged", handleSupplierChange);
    };
  }, []);

  return (
    <div className="customer-layout">
      <Navbar />
      <main className="customer-main">
        <div className="page-toolbar">
          <SearchBar />
        </div>

        <section className="compare-card">
          <header className="compare-card__header">
            <h1>Compare</h1>
          </header>

          {loading ? (
            <div className="notes-empty">Loading comparison data…</div>
          ) : error ? (
            <div className="notes-empty">{error}</div>
          ) : matrix.columns.length === 0 ? (
            <div className="notes-empty">No comparison data available yet.</div>
          ) : (
            <div className="compare-table-wrapper">
              <table className="compare-table">
                <thead>
                  <tr>
                    <th scope="col">Metric</th>
                    {matrix.columns.map((column) => (
                      <th key={column} scope="col">{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {matrix.rows.map((row) => (
                    <tr key={row.label}>
                      <th scope="row">{row.label}</th>
                      {matrix.columns.map((column, index) => (
                        <td key={`${row.label}-${column}`}>{row.values[index] || "—"}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>

        <div className="home-help">
          <HelpMessage />
        </div>
      </main>
    </div>
  );
};

export default Compare;
